export const variantSpliter = ":";

// 根据传递进来的sku list，构造出需要的数据
export const useFormatData = ({
	skuList = [],
	defaultActive = "",
} = {}) => {
	const spuVariants = [];
	const allSkuVariants = [];
	skuList.forEach(item => { 
		if(item.variantsValue && item.isfilter !== false){
			allSkuVariants.push(item.variantsValue)
		}  
	});

	const { variantsType, variantsTitle = variantsType } = skuList[0];

	const vtArr = variantsType.split(variantSpliter);
	const vtitleArr = variantsTitle.split(variantSpliter);

	vtArr.forEach((vnItem, vnIndex) => {
		const vnArrMap = {};
		for (let i = 0; i < skuList.length; i++) {
			const { variantsName, variantsValue, isfilter } = skuList[i];
			if (isfilter === false) { continue;  }
			const vvs = variantsValue.split(variantSpliter);
			const vns = variantsName.split(variantSpliter);
			vnArrMap[vvs[vnIndex]] = {
				value: vvs[vnIndex],
				name: vns[vnIndex],
			}
		}

		const vvArr = [];
		Object.keys(vnArrMap).forEach(key => {
			vvArr.push({
				...vnArrMap[key],
				isActive: false,
				isDisabled: vnIndex === 0 ? false : true,
			});
		});

		spuVariants.push({
			variantType: vtArr[vnIndex],
			variantValues: vvArr,
			variantTitle: vtitleArr[vnIndex],
		});
	});

	setVariantsActive({
		active: defaultActive.split(variantSpliter),
		spuVariants,
	});

	setVariantsDisabled({
		active: defaultActive.split(variantSpliter),
		spuVariants,
		allSkuVariants,
	});

	return {
		spuVariants,
		allSkuVariants,
	}
};

// 判断是不是color类型的variant
export const isColor = variantType => {
	return variantType && variantType === "Color";
}

// 设置variants的active状态
export const setVariantsActive = ({
	active,
	spuVariants,
}) => {
	active.forEach((activeItem, activeIdx) => {
		const matchIndex = spuVariants[activeIdx].variantValues.findIndex(item => item.value === activeItem);
		spuVariants[activeIdx].variantValues.forEach((item, index) => {
			if (index === matchIndex) {
				item.isActive = true;
			} else {
				item.isActive = false;
			}
		});
	});
}

/**
 * 根据sku组合，设置variant的disable状态，
 * 第一行的variant永远都是
 * @param {*} active: 当前选择的variant组合
 * @param {*} spuVariants：spu每层variant的item值，是一个二维数组
 * @param {*} allSkuVariants: 所有sku variantsValue组成的数组
 */
export const setVariantsDisabled = ({
	active,
	spuVariants,
	allSkuVariants,
}) => {
	// 所有以active variantsValue的第一个维度开始的sku variants
	const filterSkuKeys = allSkuVariants.filter(i => i.startsWith(active[0]));

	// 首先将除第一层以外的，其它的都要按前面的维度进行组合看是否存在
	spuVariants.forEach((spuitem, spuindex) => {
		if (spuindex > 0) {
			spuitem.variantValues.forEach((vItem) => {
				const { value } = vItem;
				const valuePrefix = active.slice(0, spuindex);
				valuePrefix.push(value);
				// const matchIndex = filterSkuKeys.find(item => item.startsWith(valuePrefix.join(variantSpliter)));
				// 由原本简单判断是否包含的逻辑，改成了判断每一层是否相等，以防最后一层有些值是以另一些值开头-20250225，midea ca
				const matchIndex = filterSkuKeys.find(item => {
					const itemArr = item.split(variantSpliter);
					const filterRes = valuePrefix.filter((pre, preI) => pre === itemArr[preI]);
					return filterRes.length === spuindex + 1;
				});
				// const tempActiveValue = active.concat([]);
				// tempActiveValue[spuindex] = value;
				// const matchIndex = filterSkuKeys.find(item => item.indexOf(tempActiveValue.join(variantSpliter)) !== -1);

				vItem.isDisabled = matchIndex ? false : true;
			});
		}
	});

	// 循环判断第2层及以上的disable状态，当前层的item是否要disable
	// filterSkuKeys.forEach((ft) => {
	// 	const frArr = ft.split(variantSpliter);
	// 	frArr.forEach((frt, fri) => {
	// 		// 只判断除第一个维度以外的维度
	// 		if (fri > 0) {
	// 			const matchIndex = spuVariants[fri].variantValues.findIndex(item => item.value === frt);
	// 			spuVariants[fri].variantValues.forEach((item, index) => {
	// 				if (matchIndex === index) {
	// 					item.isDisabled = false;
	// 				}
	// 			});
	// 		}
	// 	});
	// });
};

// 组装点击时的variant value
export const combineVariantValue = ({
	clickedItem,
	clickedLevel,
	spuVariants,
} = {}) => {
	const variantsArr = [];
	spuVariants.forEach((spuItem, spuIndex) => {
		let activeItem = clickedItem;
		if (spuIndex !== clickedLevel) {
			activeItem = spuItem.variantValues.filter(item => item.isActive)[0];
		}
		variantsArr.push(activeItem.value);
	});

	return variantsArr.join(variantSpliter);
}

// 判断是否匹配
const isMatchFn = ({
	tempArr,
	allSkuVariants,
}) => {
	// return allSkuVariants.indexOf(tempArr.join(variantSpliter)) !== -1 && tempArr.join(variantSpliter) !== oldVariantValue;
	return allSkuVariants.indexOf(tempArr.join(variantSpliter)) !== -1;
}

// 根据点击的variant，在不存在的情况下，自动切到下一个存在的组合
// eslint-disable-next-line
export const switchToExistVariantsValue = ({
	clickedItem,
	clickedLevel,
	oldVariantValue,
	allSkuVariants,
	spuVariants
} = {}) => {
	// 组装当前点击的variants是否存在
	let curVariantValue = combineVariantValue({
		clickedItem,
		clickedLevel,
		spuVariants,
	});

	// 判断当前选择的是否存在，如果存在，则直接返回，如果不存在，则要自动找下一个存在的组合
	if (allSkuVariants.indexOf(curVariantValue) === -1) {
		const matricsLen = spuVariants.length;
		let isMatch = false;

		let tempArr = [];
		tempArr = curVariantValue.split(variantSpliter).concat();

		// 获取除点击维度以外的其它维度，用于后续遍历
		const newAllVariants = [];
		spuVariants.forEach((t, i) => {
			if (i !== clickedLevel) {
				newAllVariants.push(t.variantValues);
			}
		});

		//  如果variants有两个维度
		if (matricsLen === 2) {
			for (let len1 = newAllVariants[0].length, ai1 = 0; ai1 < len1; ai1++) {
				const l1t = newAllVariants[0][ai1].value;

				if (clickedLevel === 0) {
					tempArr[1] = l1t;
				}
				if (clickedLevel === 1) {
					tempArr[0] = l1t;
				}

				if (isMatchFn({ tempArr, oldVariantValue, allSkuVariants })) {
					curVariantValue = tempArr.join(variantSpliter);
					return curVariantValue;
				}
			}
		}

		// 如果variants有三个维度
		if (matricsLen === 3) {
			let firCombLevel = 2;
			let secCombLevel = 1;
			console.log("-----", clickedLevel);
			if (clickedLevel === 2) {
				firCombLevel = 1;
				secCombLevel = 2;
			}
			// 如果点击的是第1层，则先固定1、2层，循环第3层；如果点击的是第2层，则先固定1、2层，循环第3层；如果点击的是第3层，则先固定1、3层，循环第2层；
			let newTempArr = tempArr.concat([]);
			for (let len1 = spuVariants[firCombLevel].variantValues.length, ai1 = 0; ai1 < len1; ai1++) {
				const l2t = spuVariants[firCombLevel].variantValues[ai1].value;
				newTempArr[firCombLevel] = l2t;
				if (isMatchFn({ tempArr: newTempArr, oldVariantValue, allSkuVariants })) {
					curVariantValue = newTempArr.join(variantSpliter);
					return curVariantValue;
				}
			}

			newTempArr = tempArr.concat([]);
			// 如果点击的是第1层，则再固定1、3层，循环第2测过；如果点击的是第2层，则再固定1、3层，循环第2层；如果点击的是第3层，则再固定1、2层，循环第3层；
			for (let len1 = spuVariants[secCombLevel].variantValues.length, ai1 = 0; ai1 < len1; ai1++) {
				const l2t = spuVariants[secCombLevel].variantValues[ai1].value;
				const newTempArr = tempArr.concat([]);
				newTempArr[secCombLevel] = l2t;
				if (isMatchFn({ tempArr: newTempArr, oldVariantValue, allSkuVariants })) {
					curVariantValue = newTempArr.join(variantSpliter);
					return curVariantValue;
				}
			}

			newTempArr = tempArr.concat([]);
			// 如果都没找到合适的，则第2、3维度循环，一般只有点击第1层的时候才会走到这个逻辑
			for (let len1 = spuVariants[1].variantValues.length, ai1 = 0; ai1 < len1; ai1++) {
				const l1t = spuVariants[1].variantValues[ai1].value;
				newTempArr[1] = l1t;
				for (let len2 = spuVariants[2].variantValues.length, ai2 = 0; ai2 < len2; ai2++) {
					const l2t = spuVariants[2].variantValues[ai2].value;
					newTempArr[2] = l2t;
					if (isMatchFn({ tempArr: newTempArr, oldVariantValue, allSkuVariants })) {
						isMatch = true;
						curVariantValue = newTempArr.join(variantSpliter);
						break;
					}
				}

				if (isMatch) {
					return curVariantValue;
				}
			}
		}

	}

	return curVariantValue;
};

// 根据variants value，获取对应的sku信息
export const getSkuInfo = ({
	activeVariantValue,
	skuList,
} = {}) => {
	let info = {};
	// eslint-disable-next-line
	for (const key in skuList) {
		if (activeVariantValue === skuList[key].variantsValue) {
			info = skuList[key];
		}
	}
	return info;
};
